import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const Footer = ({ height = undefined }) => {
  const currentUser = useSelector((state) => {
    const session = state.sessions.currentSession;
    return state?.[session]?.user;
  }, shallowEqual);

  const tabletSize = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const textRef = useRef(null);

  const adv_text = useMemo(
    () => currentUser?.displays?.advertising?.footer_texts || [],
    [currentUser]
  );

  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  const getRandomIndex = useCallback(() => {
    return Math.floor(Math.random() * adv_text.length);
  }, [adv_text]);

  useEffect(() => {
    if (!adv_text.length) return;

    setCurrentTextIndex(getRandomIndex()); // Initial random
    const intervalTime =
      (currentUser?.displays?.advertising?.footer_text_change_interval_min ||
        1) * 60000;

    const interval = setInterval(() => {
      setCurrentTextIndex(getRandomIndex());
    }, intervalTime);

    return () => clearInterval(interval);
  }, [adv_text, currentUser, getRandomIndex]);

  const currentText = adv_text[currentTextIndex];

  if (!currentText) return null;

  const baseStyles = {
    backgroundColor: "#1c2536",
    minHeight: height,
    py: "1rem",
    pr: "1rem",
    textAlign: "center",
    textDecoration: "none",
  };

  return currentText.link === "" ? (
    <Box className="footer" sx={baseStyles}>
      <TransitionGroup component={null}>
        <CSSTransition
          key={currentTextIndex}
          timeout={500}
          classNames="fade"
          exit={false}
          nodeRef={textRef}
        >
          <Typography
            ref={textRef}
            color="#fff"
            fontWeight="bold"
            variant={!tabletSize ? "h5" : "body1"}
            className="text-transition"
          >
            {currentText.text}
          </Typography>
        </CSSTransition>
      </TransitionGroup>
    </Box>
  ) : (
    <Box
      component="a"
      href={`https://www.${currentText.link}`}
      target="_blank"
      rel="noopener noreferrer"
      className="footer"
      sx={{
        ...baseStyles,
        zIndex: 9999999999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        ref={textRef}
        color="#fff"
        fontWeight="bold"
        variant={!tabletSize ? "h5" : "body1"}
        className="text-transition"
      >
        {currentText.text}
      </Typography>
    </Box>
  );
};

export default React.memo(Footer);
